var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReuploadCancel(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#BBB"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M24.878 25.918H7.122c-.53 0-.98-.408-.98-.938V16c0-.51.43-.939.98-.939.551 0 .98.408.98.939v8.061h15.816V16c0-.51.429-.939.98-.939.551 0 .98.408.98.939v8.98c-.041.51-.47.938-1 .938z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    stroke: "#FFF",
    d: "M16.764 10.5l3.578-3.578c.21-.211.21-.553 0-.764-.211-.21-.553-.21-.764 0L16 9.736l-3.578-3.578c-.211-.21-.553-.21-.764 0-.21.211-.21.553 0 .764l3.578 3.578-3.578 3.578c-.21.211-.21.553 0 .764.106.105.244.158.382.158s.276-.053.382-.158L16 11.264l3.578 3.578c.106.105.244.158.382.158s.276-.053.382-.158c.21-.211.21-.553 0-.764L16.764 10.5z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReuploadCancel);
export default __webpack_public_path__ + "static/media/reupload-cancel.dc67bac894e1b41ef26a9a09fb36c034.svg";
export { ForwardRef as ReactComponent };